import { useParams } from 'react-router-dom';
import { api } from '@/api/client';
import { EmptyState } from '@/components/EmptyState';
import { Topbar } from '@/components/Topbar';
import { useAsync } from '@/hooks/useAsync';
import { fmtRelative } from '@/lib/format';

export function AccountDialogsPage(): JSX.Element {
  const { id } = useParams();
  const accountId = Number(id);
  const { data: account } = useAsync(() => api.getAccount(accountId), [accountId]);
  const { data: dialogs, loading, error } = useAsync(() => api.listAccountDialogs(accountId), [accountId]);

  if (loading) {
    return (
      <div className="space-y-3">
        <Topbar title="Диалоги" subtitle={account?.username ? `@${account.username}` : undefined} />
        <div className="skeleton h-24" />
        <div className="skeleton h-24" />
      </div>
    );
  }

  return (
    <div className="space-y-4 pb-8">
      <Topbar
        title="Диалоги"
        subtitle={account?.name || account?.username || (account ? `Аккаунт #${account.id}` : undefined)}
      />

      {!dialogs?.length ? (
        <EmptyState
          icon="inbox"
          title="Диалогов нет"
          body={error || 'Для этого аккаунта пока не найдено активных тредов.'}
        />
      ) : (
        <ul className="space-y-3">
          {dialogs.map((dialog) => (
            <li key={dialog.id} className="card p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="truncate text-[15px] font-semibold text-white">{dialog.fromName}</div>
                  <div className="mt-1 truncate text-[13px] text-[#7e87aa]">
                    {dialog.fromUsername ? `${dialog.fromUsername} · ` : ''}
                    {dialog.campaignName || 'без кампании'}
                  </div>
                </div>
                <span className="rounded-full border border-white/10 bg-white/4 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-[#cdd5f5]">
                  {dialog.kind}
                </span>
              </div>
              <div className="mt-3 text-[14px] leading-6 text-white">{dialog.preview}</div>
              <div className="mt-3 flex items-center justify-between text-[12px] text-[#7e87aa]">
                <span>{fmtRelative(dialog.lastAt)}</span>
                <span>{dialog.unreadCount > 0 ? `непрочитано: ${dialog.unreadCount}` : 'прочитано'}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
